import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

// NOTE: NSAI-6530 — Databricks' brand mark: one path in the brand red
// (#ff3621, hsl 6 100% 56%), tinted from its own hue like the other
// integration icons.
const DatabricksComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="hsl(from hsl(6 100% 56%) h s 56%)"
      d="M1.155,4.93v.512L9,9.868l7.006-3.957,0,1.6L9,11.491,1.55,7.258l-.395.22V10.54L9,14.955l7.006-3.942,0,1.586L9,16.581,1.55,12.347l-.395.22v.519L9,17.5l7.845-4.414V10.021l-.4-.218L9,14.036,1.992,10.054V8.476L9,12.414,16.845,8V4.978l-.4-.219L9,8.993,2.352,5.215,9,1.46l5.476,3.094.479-.269V3.863L9,.5Z"
    />
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components.
export const Databricks = memo(DatabricksComponent);
